import { TFunction } from "i18next";

import type { Order } from "../../../../../../../services";
import { isPaymentLinkSmsPending } from "../../../../../../../utils/orderPaymentStatus";

/**
 * The payment type text. The payment stage color moved to the "Payment
 * status" column; a cash order with a link sent by SMS reads as awaiting it.
 */
const cellProcessing = (
	item?: Order.Model,
	t?: TFunction,
): { content: string; backgroundColor?: string; textColor?: string } => {
	if (!item || !t) {
		return { content: "" };
	}

	if (isPaymentLinkSmsPending(item)) {
		return { content: t("order_payment_type.payment_link_pending") ?? "" };
	}

	return { content: t(`order_payment_type.${item.paymentType}`) };
};

export default cellProcessing;
